
import { Prop, Vue, Watch } from 'vue-property-decorator';
import ProgressBarData from './ProgressBarData';
export default class ProgressBar extends Vue {
  @Prop({ default: new ProgressBarData(0, true) }) readonly progressBarData: ProgressBarData | undefined;
  @Prop({ default: '#5a5d95' }) readonly progressBarColor: string | undefined;

  @Watch('progressBarData')
  private onItemChanged(newProgressBarData: ProgressBarData): void {
    this.adjustProgressBar(newProgressBarData);
  }

  mounted(): void {
    this.adjustProgressBar(this.progressBarData);
  }

  private adjustProgressBar(progressBarData: ProgressBarData | undefined): void {
    if (!document.getElementById('progress')) {
      return;
    }
    let progressBarDataValue = new ProgressBarData(0, true);
    if (progressBarData) {
      progressBarDataValue = progressBarData;
    }

    let currentValue: string = document.getElementById('progress')!.style.width;
    if (!currentValue) {
      currentValue = '0%';
    }

    this.handleAdjust(progressBarDataValue, parseInt(currentValue.substring(0, currentValue.indexOf('%'))));
  }

  private handleAdjust(progressBarData: ProgressBarData, currentValue: number) {
    if (progressBarData.percentage !== currentValue) {
      if (!progressBarData.animateChange) {
        currentValue = progressBarData.percentage;
      } else {
        currentValue = currentValue < progressBarData.percentage ? currentValue + 1 : currentValue - 1;
      }
      const element = document.getElementById('progress');
      if (element) {
        element.style.width = currentValue + '%';
        if (progressBarData.animateChange) {
          setTimeout(() => this.handleAdjust(progressBarData, currentValue), 2);
        }
      }
    }
  }
}
